/* eslint-disable max-classes-per-file */

import Base, { ErrorBase } from 'requests/objects/_base'

/**
 * User Object
 */
export default class User extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.userId userId
     * @param {string=} data.email email
     * @param {number=} data.profileId profileId
     * @param {object[]=} data.companies companies
     * @param {string=} data.firstname firstname
     * @param {string=} data.lastname lastname
     * @param {string=} data.accessToken accessToken
     * @param {string=} data.refreshToken refreshToken
     */
    constructor({
        userId,
        email,
        profileId,
        companies,
        firstname,
        lastname,
        accessToken,
        refreshToken,
        ...data
    } = {}) {
        super(data)
        this.userId = userId
        this.email = email
        this.profileId = profileId
        this.companyIds = companies?.map(x => x.code) ?? []
        this.firstname = firstname
        this.lastname = lastname
        this.accessToken = accessToken
        this.refreshToken = refreshToken
        this.name = `${firstname} ${lastname}`
    }
}

/**
 * User Object used to bind error message
 */
export class ErrorUser extends ErrorBase {
    constructor() {
        super()
        this.userId = ''
        this.companyIds = ''
        this.email = ''
        this.profileId = ''
    }
}
